export function randomNonce(length = 16): string {
  const bytes = (typeof crypto !== 'undefined' && crypto.getRandomValues)
    ? crypto.getRandomValues(new Uint8Array(length))
    : new Uint8Array(length).map(() => Math.floor(Math.random() * 256));
  return Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('');
}
